import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import APIKit from "../../Middleware/axiosConfig";

// API End Points
import { API_END_POINTS } from "../../Middleware/apiEndpoints";

//utils
import { notifyError } from "Services/Utils/toastNotification";

// Product Training
export const fetchProductTrainingList = createAsyncThunk(
  "fetchProductTrainingList",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.productTrainingList}?page=${data.page}&limit=${data.limit}&sort_by=${data.sort_by}&order_by=${data.order_by}&search=${data.search}`
    );
    console.log("PTP", response);
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      console.log(
        `Error ===> ${API_END_POINTS.sample} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);
export const editProductTrainingListStatus = createAsyncThunk(
  "editProductTrainingListStatus",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.editProductTrainingListStatus}/${data.status}/${data.id}`
    );
    console.log("PTP", response);
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);

      console.log(
        `Error ===> ${API_END_POINTS.sample} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);
export const deleteProductTraining = createAsyncThunk(
  "deleteProductTraining",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().delete(
      `${API_END_POINTS.deleteProductTraining}/${data.id}`
    );
    console.log("PTP", response);
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);

      console.log(
        `Error ===> ${API_END_POINTS.sample} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);
export const fetchProductTrainingCategory = createAsyncThunk(
  "fetchProductTrainingCategory",
  async ({ callBack }) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.productTrainingGetCategory}`
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);

      console.log(
        `Error ===> ${API_END_POINTS.sample} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);
export const fetchProductTrainingSubCategory = createAsyncThunk(
  "fetchProductTrainingSubCategory",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.productTrainingGetSubCategory}/${data}`
    );
    // console.log('PTP',response)
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);

      console.log(
        `Error ===> ${API_END_POINTS.sample} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);
export const addProductTraining = createAsyncThunk(
  "addProductTraining",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.addProductTraining}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${API_END_POINTS.staffStatusChange} ====> ${JSON.stringify(
          response
        )}`
      );
    }
    return response?.data;
  }
);
export const fetchIndividualProductTraining = createAsyncThunk(
  "fetchIndividualProductTraining",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.individualProductTraining}/${data.id}`
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${
          API_END_POINTS.individualProductTraining
        } ====> ${JSON.stringify(response)}`
      );
    }
    return response?.data;
  }
);
export const editProductTraining = createAsyncThunk(
  "editProductTraining",
  async ({ data, callBack, id }) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.editProductTraining}/${id}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${
          API_END_POINTS.editProductTraining
        } ====> ${JSON.stringify(response)}`
      );
    }
    return response?.data;
  }
);

// Industry Training
export const fetchIndustryTrainingList = createAsyncThunk(
  "fetchIndustryTrainingList",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.industryTrainingList}?page=${data.page}&limit=${data.limit}&sort_by=${data.sort_by}&order_by=${data.order_by}&search=${data.search}`
    );
    console.log("PTP", response);
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);

      console.log(
        `Error ===> ${API_END_POINTS.sample} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);
export const editIndustryTrainingListStatus = createAsyncThunk(
  "editIndustryTrainingListStatus",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.editIndustryTrainingListStatus}/${data.status}/${data.id}`
    );
    console.log("PTP", response);
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);

      console.log(
        `Error ===> ${API_END_POINTS.sample} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);
export const deleteIndustryTraining = createAsyncThunk(
  "deleteIndustryTraining",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().delete(
      `${API_END_POINTS.deleteIndustryTraining}/${data.id}`
    );
    console.log("PTP", response);
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);

      console.log(
        `Error ===> ${API_END_POINTS.sample} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);
export const fetchIndustryTrainingCategory = createAsyncThunk(
  "fetchIndustryTrainingCategory",
  async ({ callBack }) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.industryTrainingGetCategory}`
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);

      console.log(
        `Error ===> ${API_END_POINTS.sample} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);
export const addIndustryTraining = createAsyncThunk(
  "addIndustryTraining",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.addIndustryTraining}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${
          API_END_POINTS.addIndustryTraining
        } ====> ${JSON.stringify(response)}`
      );
    }
    return response?.data;
  }
);
export const fetchIndividualIndustryTraining = createAsyncThunk(
  "fetchIndividualIndustryTraining",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.individualIndustryTraining}/${data.id}`
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${
          API_END_POINTS.individualIndustryTraining
        } ====> ${JSON.stringify(response)}`
      );
    }
    return response?.data;
  }
);
export const editIndustryTraining = createAsyncThunk(
  "editIndustryTraining",
  async ({ data, callBack, id }) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.editIndustryTraining}/${id}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${
          API_END_POINTS.editIndustryTraining
        } ====> ${JSON.stringify(response)}`
      );
    }
    return response?.data;
  }
);

// Banners and Promotions
export const fetchBannerList = createAsyncThunk(
  "fetchBannerList",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.bannerList}?page=${data.page}&limit=${data.limit}&sort_by=${data.sort_by}&order_by=${data.order_by}&search=${data.search}`
    );
    console.log("PTP", response);
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);

      console.log(
        `Error ===> ${API_END_POINTS.sample} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);
export const editBannerListStatus = createAsyncThunk(
  "editBannerListStatus",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.editBannerStatus}/${data.status}/${data.id}`
    );
    console.log("PTP", response);
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);

      console.log(
        `Error ===> ${API_END_POINTS.sample} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);
export const deleteBanner = createAsyncThunk(
  "deleteBanner",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().delete(
      `${API_END_POINTS.deleteBanner}/${data.id}`
    );
    console.log("PTP", response);
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);

      console.log(
        `Error ===> ${API_END_POINTS.sample} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);
export const addBanners = createAsyncThunk(
  "addBanners",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().post(`${API_END_POINTS.addBanner}`, data);
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${API_END_POINTS.addBanner} ====> ${JSON.stringify(
          response
        )}`
      );
    }
    return response?.data;
  }
);
export const fetchIndividualBanner = createAsyncThunk(
  "fetchIndividualBanner",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.individualBanner}/${data.id}`
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${API_END_POINTS.individualBanner} ====> ${JSON.stringify(
          response
        )}`
      );
    }
    return response?.data;
  }
);
export const editBanners = createAsyncThunk(
  "editFAQ",
  async ({ data, callBack, id }) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.editBanner}/${id}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${API_END_POINTS.editBanner} ====> ${JSON.stringify(
          response
        )}`
      );
    }
    return response?.data;
  }
);

// FAQs
export const fetchFAQList = createAsyncThunk(
  "fetchFAQList",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.faqList}?page=${data.page}&limit=${data.limit}&sort_by=${data.sort_by}&order_by=${data.order_by}&search=${data.search}`
    );
    console.log("PTP", response);
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);

      console.log(
        `Error ===> ${API_END_POINTS.sample} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);
export const editFAQListStatus = createAsyncThunk(
  "editFAQListStatus",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.editFAQStatus}/${data.status}/${data.id}`
    );
    console.log("PTP", response);
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);

      console.log(
        `Error ===> ${API_END_POINTS.sample} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);
export const deleteFAQ = createAsyncThunk(
  "deleteFAQ",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().delete(
      `${API_END_POINTS.deleteFAQ}/${data.id}`
    );
    console.log("PTP", response);
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);

      console.log(
        `Error ===> ${API_END_POINTS.sample} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);
export const addFAQs = createAsyncThunk(
  "addFAQs",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().post(`${API_END_POINTS.addFAQ}`, data);
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${API_END_POINTS.addFAQ} ====> ${JSON.stringify(response)}`
      );
    }
    return response?.data;
  }
);
export const fetchIndividualFAQ = createAsyncThunk(
  "fetchIndividualFAQ",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.individualFAQ}/${data.id}`
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${API_END_POINTS.individualFAQ} ====> ${JSON.stringify(
          response
        )}`
      );
    }
    return response?.data;
  }
);
export const editFAQs = createAsyncThunk(
  "editFAQs",
  async ({ data, callBack, id }) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.editFAQ}/${id}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${API_END_POINTS.editFAQ} ====> ${JSON.stringify(response)}`
      );
    }
    return response?.data;
  }
);

// Offer Codes
export const fetchOfferCodeList = createAsyncThunk(
  "fetchOfferCodeList",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.offerCodeList}?page=${data.page}&limit=${data.limit}&sort_by=${data.sort_by}&order_by=${data.order_by}&search=${data.search}`
    );
    console.log("PTP", response);
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);

      console.log(
        `Error ===> ${API_END_POINTS.sample} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);
export const editOfferCodeListStatus = createAsyncThunk(
  "editOfferCodeListStatus",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.editOfferCodeStatus}/${data.status}/${data.id}`
    );
    console.log("PTP", response);
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);

      console.log(
        `Error ===> ${API_END_POINTS.sample} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);
export const deleteOfferCode = createAsyncThunk(
  "deleteOfferCode",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().delete(
      `${API_END_POINTS.deleteOfferCode}/${data.id}`
    );
    console.log("PTP", response);
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);

      console.log(
        `Error ===> ${API_END_POINTS.sample} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);
export const addOfferCodes = createAsyncThunk(
  "addOfferCodes",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.addOfferCode}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${API_END_POINTS.addOfferCode} ====> ${JSON.stringify(
          response
        )}`
      );
    }
    return response?.data;
  }
);
export const fetchIndividualOfferCode = createAsyncThunk(
  "fetchIndividualOfferCode",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.individualOfferCode}/${data.id}`
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${
          API_END_POINTS.individualOfferCode
        } ====> ${JSON.stringify(response)}`
      );
    }
    return response?.data;
  }
);
export const editOfferCodes = createAsyncThunk(
  "editOfferCodes",
  async ({ data, callBack, id }) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.editOfferCode}/${id}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${API_END_POINTS.editOfferCode} ====> ${JSON.stringify(
          response
        )}`
      );
    }
    return response?.data;
  }
);

export const contentManagementSlice = createSlice({
  name: "contentManagement",
  initialState: { isLoading: false },
  reducers: {},
  extraReducers: (builder) => {
    //Product Training List
    builder
      .addCase(fetchProductTrainingList.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchProductTrainingList.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchProductTrainingList.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(editProductTrainingListStatus.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(editProductTrainingListStatus.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(editProductTrainingListStatus.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(deleteProductTraining.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(deleteProductTraining.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(deleteProductTraining.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchProductTrainingCategory.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchProductTrainingCategory.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchProductTrainingCategory.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchProductTrainingSubCategory.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchProductTrainingSubCategory.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchProductTrainingSubCategory.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchIndividualProductTraining.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchIndividualProductTraining.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchIndividualProductTraining.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(addProductTraining.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(addProductTraining.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(addProductTraining.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(editProductTraining.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(editProductTraining.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(editProductTraining.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Industry Training List
    builder
      .addCase(fetchIndustryTrainingList.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchIndustryTrainingList.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchIndustryTrainingList.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(editIndustryTrainingListStatus.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(editIndustryTrainingListStatus.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(editIndustryTrainingListStatus.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(deleteIndustryTraining.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(deleteIndustryTraining.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(deleteIndustryTraining.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchIndustryTrainingCategory.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchIndustryTrainingCategory.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchIndustryTrainingCategory.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchIndividualIndustryTraining.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchIndividualIndustryTraining.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchIndividualIndustryTraining.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(addIndustryTraining.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(addIndustryTraining.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(addIndustryTraining.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(editIndustryTraining.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(editIndustryTraining.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(editIndustryTraining.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Banner List
    builder
      .addCase(fetchBannerList.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchBannerList.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchBannerList.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(editBannerListStatus.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(editBannerListStatus.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(editBannerListStatus.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(deleteBanner.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(deleteBanner.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(deleteBanner.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchIndividualBanner.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchIndividualBanner.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchIndividualBanner.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(addBanners.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(addBanners.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(addBanners.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(editBanners.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(editBanners.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(editBanners.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //FAQ List
    builder
      .addCase(fetchFAQList.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchFAQList.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchFAQList.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(editFAQListStatus.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(editFAQListStatus.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(editFAQListStatus.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(deleteFAQ.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(deleteFAQ.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(deleteFAQ.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchIndividualFAQ.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchIndividualFAQ.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchIndividualFAQ.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(addFAQs.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(addFAQs.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(addFAQs.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(editFAQs.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(editFAQs.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(editFAQs.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Offer Code List
    builder
      .addCase(fetchOfferCodeList.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchOfferCodeList.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchOfferCodeList.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(editOfferCodeListStatus.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(editOfferCodeListStatus.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(editOfferCodeListStatus.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(deleteOfferCode.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(deleteOfferCode.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(deleteOfferCode.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchIndividualOfferCode.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchIndividualOfferCode.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchIndividualOfferCode.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(addOfferCodes.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(addOfferCodes.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(addOfferCodes.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(editOfferCodes.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(editOfferCodes.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(editOfferCodes.rejected, (state, action) => {
        state.isLoading = "failed";
      });
  },
});

export default contentManagementSlice.reducer;
